'use client'
import ErrorHandler from "@/components/ErrorHandler"

// Error boundaries must be Client Components

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {


  return (
    // global-error must include html and body tags
    <html>
      <body>
        <ErrorHandler
          reset={reset}
          error={error}></ErrorHandler>
      </body>
    </html>
  )
}